/**
 * Linenatura — Recently viewed products
 * - Guarda hasta 8 productos visitados en localStorage
 * - Renderiza una sección "Vistos recientemente" en producto
 * - Excluye el producto actual y los agotados
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'ln_recently_viewed_v1';
  var MAX_ITEMS = 8;

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function addCurrent(handle) {
    if (!handle) return;
    var list = getList();
    list = list.filter(function (h) { return h !== handle; });
    list.unshift(handle);
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    saveList(list);
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function buildCard(product) {
    var url = product.url || '/products/' + product.handle;
    var img = product.featured_image || (product.images && product.images[0]);
    var imgUrl = img ? (typeof img === 'string' ? img : img.src) : '';
    var imgSrc = imgUrl ? imgUrl.replace(/(\.(?:jpg|jpeg|png|webp|avif))(\?.*)?$/i, '_400x$1$2') : '';
    var price = product.price !== undefined ? formatMoney(product.price) : '';
    var compareAt = product.compare_at_price && product.compare_at_price > product.price
      ? formatMoney(product.compare_at_price)
      : '';

    var li = document.createElement('li');
    li.className = 'ln-recent__item';

    var html =
      '<a href="' + url + '" class="ln-recent__link">' +
      (imgSrc
        ? '<div class="ln-recent__image"><img src="' + imgSrc + '" alt="' + (product.title || '') + '" loading="lazy"></div>'
        : '') +
      '<div class="ln-recent__info">' +
      '<h3 class="ln-recent__title">' + (product.title || '') + '</h3>' +
      '<div class="ln-recent__price">' +
      '<span>' + price + '</span>' +
      (compareAt ? '<s class="ln-recent__compare">' + compareAt + '</s>' : '') +
      '</div>' +
      '</div>' +
      '</a>';
    li.innerHTML = html;
    return li;
  }

  function getCurrentHandle() {
    var path = window.location.pathname;
    var match = path.match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  function render(container, currentHandle) {
    var list = getList().filter(function (h) { return h !== currentHandle; });
    if (!list.length) return;

    var listEl = container.querySelector('[data-recent-list]');
    if (!listEl) return;

    var promises = list.slice(0, 6).map(fetchProduct);
    Promise.all(promises).then(function (results) {
      var visible = 0;
      results.forEach(function (p) {
        if (!p || !p.available) return;
        var card = buildCard(p);
        listEl.appendChild(card);
        visible++;
      });
      if (visible > 0) {
        container.classList.add('ln-recent--ready');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var currentHandle = getCurrentHandle();

    // Save current product to history (only on product pages)
    if (currentHandle) {
      addCurrent(currentHandle);
    }

    // Render section if container exists
    var container = document.querySelector('[data-recently-viewed]');
    if (container) {
      render(container, currentHandle);
    }
  });
})();
